import type { FaireProductEntity } from "../../entity_types/product";

export const p_yysfkvv8jb: FaireProductEntity = {
  token: "p_yysfkvv8jb",
  type: "product",
  name: "Journal (Pink) - People I Beat at Mahjong",
  brandToken: "b_ec75fc82",
  brandName: "Toss Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/7e0074fe903af881fdf64a1aee98e3b1474a23c96ded8e13b9edef27e397a130.jpeg",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    '"People I Beat at Mahjong" - Pink Journal\n\nWhether you’re tracking your daily habits or plans, or your looking for the perfect gift for a loved one, this vegan leather journal is the perfect fit! \n\n- Perfect for mahjong lovers!\n- 5.5” x 8.5”\n- Vegan leather\n- Case size of 3\n\n',
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:37.982Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
